import { StatusesEnum } from '@enums';
/**
 * Get chip color by status.
 *
 * @author Ihar Kazlouski
 * @param {string} status.
 * @return {string} chip color.
 */

var getChipColor = function getChipColor(status) {
  if (status === StatusesEnum.Active) {
    return 'seaGreen';
  }

  if (status === StatusesEnum.Block) {
    return 'bitterSweet';
  }

  if (status === StatusesEnum.PinLocked) {
    return 'sunshade';
  }

  return 'athensGray';
};

export { getChipColor };